export const ROUTER_NAME_FIBRA = 'Router Fibra'
export const ROUTER_NAME_ADSL = 'Router ADSL'
